import { render, staticRenderFns } from "./medicine-order-details-program-freestylelibre.vue?vue&type=template&id=70ca7fd1&scoped=true"
import script from "./medicine-order-details-program-freestylelibre.vue?vue&type=script&lang=js"
export * from "./medicine-order-details-program-freestylelibre.vue?vue&type=script&lang=js"
import style0 from "./medicine-order-details-program-freestylelibre.vue?vue&type=style&index=0&id=70ca7fd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca7fd1",
  null
  
)

export default component.exports